import { ErrorHandler } from "../error-handler";
import { HttpHeaders } from "../../../../utils/http-utils";
import { curriedGet, curriedPatch, curriedPost } from "../abort-controller";
import { AxiosError } from "axios";
import { LegalTerms } from "../../../Authentication/models/legal-terms";

export class TermsAndConditionsService {
  errorHandler = new ErrorHandler("Terms and conditions service");

  private static readonly apiUrl = "/api/user/terms";

  private readonly config: {
    baseURL: string;
    timeout: number;
    headers: HttpHeaders;
  };

  constructor(private baseURL: string) {
    this.config = {
      baseURL: this.baseURL,
      timeout: 3000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  }

  async check() {
    const responsePromise = curriedGet(TermsAndConditionsService.apiUrl, this.config);

    return await responsePromise
      .then((res) => {
        return res.data;
      })
      .catch((e: string | AxiosError) => {
        this.errorHandler.handle(e, "terms-and-conditions-service");
        return false;
      });
  }

  async accept(terms: Array<LegalTerms>) {
    const responsePromise = curriedPatch(TermsAndConditionsService.apiUrl, this.config, true, JSON.stringify(terms));
    return await responsePromise.catch((e: string | AxiosError) => {
      if (typeof e === "string") {
        throw e;
      }
      throw this.errorHandler.handle(e, "terms-and-conditions-service");
    });
  }
}
